import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import bestStreamer from "@/assets/euro26-best-streamer-2026.png.asset.json";

const Footer = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <footer className="relative z-10 py-8 px-4 border-t border-border/30 bg-background">
      <div className="container mx-auto max-w-6xl text-center text-xs text-muted-foreground">
        <div className="mb-4 flex justify-center items-center">
          <img src={bestStreamer.url} alt="EURO26 Award Winner — Best Streamer 2026 — GamDucks" className="h-24 md:h-28 w-auto opacity-90" loading="lazy" />
        </div>
        <nav className="mb-3 flex flex-wrap justify-center items-center gap-x-3 gap-y-1">
          <Link to="/terms" className="hover:text-foreground hover:underline transition-colors">
            Terms of Service
          </Link>
          <span className="opacity-50">·</span>
          <Link to="/privacy" className="hover:text-foreground hover:underline transition-colors">
            Privacy Policy
          </Link>
          <span className="opacity-50">·</span>
          <Link to="/support" className="hover:text-foreground hover:underline transition-colors">
            Support
          </Link>
        </nav>
        <p className="mb-4">© All Rights Reserved 2025.</p>
        
        {/* Desktop: always visible */}
        <p className="hidden md:block max-w-4xl mx-auto">
          BeGambleAware | Gambling should be treated as entertainment, not a way to make money. Only gamble with money you can afford to lose and set clear limits on both the time and money you spend. Never chase losses and avoid using gambling as a way to escape everyday problems.
          {"\n\n"}
          We are not responsible for any losses related to gambling or for the content found on this website, including advertisements. Gambling is strictly for individuals aged 18 or older, or the legal age required in your jurisdiction.
        </p>

        {/* Mobile: collapsible */}
        <div className="md:hidden max-w-4xl mx-auto">
          <p className="text-[10px]">
            BeGambleAware | 18+
          </p>
          <div
            className="overflow-hidden transition-all duration-300 ease-in-out"
            style={{ maxHeight: expanded ? "500px" : "0px", opacity: expanded ? 1 : 0 }}
          >
            <p className="text-[10px] mt-2">
              Gambling should be treated as entertainment, not a way to make money. Only gamble with money you can afford to lose and set clear limits on both the time and money you spend. Never chase losses and avoid using gambling as a way to escape everyday problems.
              {"\n\n"}
              We are not responsible for any losses related to gambling or for the content found on this website, including advertisements. Gambling is strictly for individuals aged 18 or older, or the legal age required in your jurisdiction.
            </p>
          </div>
          <button
            onClick={() => setExpanded(!expanded)}
            className="mt-2 text-[10px] text-muted-foreground hover:text-foreground flex items-center gap-1 mx-auto transition-colors"
          >
            {expanded ? "Show less gambling awareness details" : "Read gambling awareness details"}
            <ChevronDown
              className={`h-3 w-3 transition-transform duration-300 ${expanded ? "rotate-180" : ""}`}
            />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
